import React from 'react'
import { Button, Typography } from 'antd'
import { Link } from 'react-router-dom'
import { Home, FileQuestion } from 'lucide-react'
import { SprintSpecLogo } from '../../components/Logo/SprintSpecLogo'
import { usePageTitle } from '../../utils/pageTitle'

const { Title, Text } = Typography

export const NotFoundPage: React.FC = () => {
  usePageTitle('Page not found')
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-white border-b px-6 py-4">
        <SprintSpecLogo />
      </header>

      <main className="flex-1 flex items-center justify-center p-4">
        <div className="text-center max-w-lg">
          <div className="mb-8 relative">
            <FileQuestion className="h-32 w-32 mx-auto text-primary opacity-20" />
            <div className="absolute inset-0 flex items-center justify-center">
              <Title level={1} className="text-6xl font-bold mb-0">
                404
              </Title>
            </div>
          </div>

          <Title level={2} className="mb-4">
            Page Not Found
          </Title>

          <Text className="text-gray-600 block mb-8">
            The page you're looking for doesn't exist or has been moved. Let's
            get you back on track.
          </Text>

          <Link to="/">
            <Button
              type="primary"
              icon={<Home className="h-4 w-4" />}
              size="large"
            >
              Back to Home
            </Button>
          </Link>
        </div>
      </main>
    </div>
  )
}
